module.exports = __webpack_public_path__ + "media/images/emblems/Bedano-coat_of_arms-0777332f62d32a1a8a22687bc415dfc8.svg";